//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import viewRelateFlow from '@/components/browse/view-relate-flow';
import commonsReport from '@/components/commons-report';

export default {
  name: "contract-view",
  components: {
    viewRelateFlow,
    commonsReport
  },
  data() {
    return {
      headerTitle: "采购合同详情",
      contractDto: {},
      selectModel: 'base',
      contractId: null,
      switchIndex: 0,
      dataImg: '',
      bigImg: false,
      isSupplier: false,
      isDownload: true,
      isSign: true,
      signFileList: [],
      signVisible: false,
      signObj: {},
    }
  },
  methods: {
    changeShowModel(str) {
      this.selectModel = str;
      if (str === 'attach') {
        if (this.isSupplier) {
          if (this.contractDto && this.contractDto.contractFileList) {
            this.contractDto.contractFileList = this.contractDto.contractFileList.filter((item) => {
              return item.supViewAuthority === 'open';
            })
          }
        }
      } else if (str == "view") {
        this.getContractHtml();
      }
    },
    signModalOk() {
      this.loading = true;
      if (!this.signObj.files) {
        this.$message.error('至少选择一份文件进行签署！');
        this.loading = false;
        return;
      }
      this.$get(`api/contract-lock/sendSignByFile/${this.contractId}/${this.signObj.files}`).then((data) => {
        if (data) {
          this.$message.success('文件签署发起成功！');
          this.signVisible = false;
          this.signObj = {};
          this.isSign = false;
          this.isDownload = false;
        } else {
          this.$message.warning(data.message);
          this.loading = false;
        }
      }, () => this.loading = false, () => this.loading = false);
    },
    signModalCancel() {
      this.signVisible = false;
      this.signObj = {};
    },
    signContract() {
      this.$get('api/contract-lock/verify').then((flag) => {
        if (!flag) {
          this.$message.error('电子签章功能未开启,请开启后在使用！');
        } else {
          if (this.contractDto.templeteType === 'offlineContract') {
            this.$get(`api/contract-base/file/${this.contractId}`).then((res) => {
              if (res) {
                this.signFileList = res;
              }
            })
            this.signVisible = true;
          } else {
            this.$confirm('是否确认发起在线签署合同？', '提交确认？', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              okType: 'warning',
              customClass: 'myClass'
            }).then(() => {
              this.$get(`api/contract-lock/sendSignByModel/${this.contractId}`).then((data) => {
                if (data) {
                  this.isSign = false;
                  this.isDownload = false;
                  this.$message.success('文件签署发起成功！');
                } else {
                  this.$message.warning(data.message);
                }
              }, () => this.loading = false, () => this.loading = false)
            })
          }
        }
      });
    },
    getContractDto() {
      this.$loadingShow();
      this.$get(`api/contract-base/${this.contractId}`).then((res) => {
        if (res) {
          this.contractDto = res;
          // 判断无变更和中止流程进行中
          if (this.contractDto.workflowExistFlag != '0') {
            this.isSign = false;
          }
          // 判断流程是否已发布
          if (this.contractDto.status != 'end' && this.contractDto.status != 'delete') {
            this.isSign = false;
          } else {
            if (this.contractDto.contractLockId) {
              if (this.contractDto.contractStatus != 'sfyq') {
                this.isSign = false;
              }
            }
          }
          if (this.contractDto.contractLockId && this.contractDto.contractStatus == 'sfyq') {
            this.isDownload = true;
          }
          if (this.contractDto.contractMdlRelCopyList) {
            let list = [];
            this.contractDto.contractMdlRelCopyList.forEach((item) => {
              if (item.contractModel) {
                list.push(item.contractModel.pactName)
              }
            });
            this.contractDto.contractMdlStr = list.join(',');
          }
          if (this.contractDto.contractModelRelCopy && this.contractDto.contractModelRelCopy.contractModel) {
            this.contractDto.contractMdlStr = this.contractDto.contractModelRelCopy.contractModel;
          }
          let ImgObj = {deploymentId: '', requestId: this.contractDto.currentRequestId, time: new Date().getTime()};
          let imgData = '';
          for (let key in ImgObj) {
            imgData += '&' + key + '=' + ImgObj[key];
          }
          imgData = imgData.slice(1);
          imgData = '?' + imgData;
          this.dataImg = process.env.API_ROOT + 'api/act/resource/read/' + imgData;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    switchTabItem(i) {
      this.switchIndex = i;
    },
    changeShow(data) {
      if (data.cellShow) {
        this.$set(data, 'cellShow', false);
        return;
      }
      this.$set(data, 'cellShow', true);
    },
    changeSelected(data, str) {
      this.$set(data, 'selectShow', str);
    },
    getPerson() {
      this.$get('api/user/current').then((userData) => {
        this.isSupplier = !(this.$store.state.userTypeDk == 'INTER_USER' || !this.$store.state.userTypeDk);
      })
    },
    view(str) {
      if (str === 'source') {
        this.$router.push(`/sources/${this.contractDto.sourceId}`);
      } else if (str === 'contract') {
        this.$router.push(`/contract/${this.contractDto.linkedContractBaseId}`);
      } else if (str === 'compare') {
        if (this.contractDto.comparePriceId && this.contractDto.comparePriceId != null && this.contractDto.comparePriceId != null  && this.contractDto.comparePriceId != undefined) {
          this.$router.push(`/parity-detail/${this.contractDto.comparePriceId}`);
        }
      }
    },
    getContractHtml() {
      if (this.contractDto.contractMdlRelCopyList && this.contractDto.contractMdlRelCopyList.length) {
        this.contactView(this.contractDto.contractMdlRelCopyList[0]);
      } else {
        this.$loadingShow();
        this.$get(`api/contract-base/getContractHtml/${this.contractId}`).then((data) => {
          if (data.str) {
            this.contractHtml = data.str;
            this.viewIframe(this.contractHtml);
          }
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        })
      }
    },
    contactView(item) {
      this.$loadingShow();
      this.$get(`api/contract-base/getContractHtml/${this.contractId}/${item.contractModel.id}`).then((data) => {
        if (data.str) {
          this.contractHtml = data.str;
          this.viewIframe(this.contractHtml);
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    viewIframe(data) {
      setTimeout(() => {
        this.ifr = document.getElementById('iframeTem');
        let iframeDoc = this.ifr.contentDocument || this.ifr.contentWindow.document;
        iframeDoc.children[0].innerHTML = data;
      });
    }
  },
  mounted() {
    this.contractId = this.$route.params.id;
    if (this.$route.params.type == 'query') {
      this.headerTitle = "合同明细查询详情"
    }
    this.getContractDto();
    this.getPerson();
  },
  watch: {
    '$route': function () {
      this.contractId = this.$route.params.id;
      this.selectModel = 'base';
      this.switchIndex = 0;
      this.getContractDto();
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/contract/contract-view.vue